import React, {useState} from 'react'
import { Block, Button } from '@xprog/prensa'
import { Input } from '../Input/Input.styles'
import { PrensaEngineCSSProp } from '@xprog/prensa/types'
import ReCAPTCHA from 'react-google-recaptcha';
import { selectionOption } from './select.options'
import queryString from 'query-string';
import {toast} from 'react-toastify'
import { getStoreId } from 'utils/getStoreId';

type InputAreaProps = {
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void
    css?: {
      container?: PrensaEngineCSSProp
      input?: PrensaEngineCSSProp
    }
    // inputRef: any
    value?: any
  }

const InputArea = ({onChange, onKeyPress, css}: InputAreaProps) => {
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [formattedFone, setFormattedFone] = useState('')
  const [selectedOption, setSelectedOption] = useState<String>('Outros');
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState ('')
  const [loading, setLoading] = useState(false)
  const [input, setInput] = useState({
    name,
    email,
    message
  })

  const handleInputChange = (fieldName: string, value: string) => {
    setInput(prevState => ({
      ...prevState,
      [fieldName]: value
    }))
  }

  const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedOption(value);
  };

  const formatPhone = (fone: string) => {
    let numbers = fone.replace(/\D/g, '');
    if (numbers.length <= 2) {
      return numbers;
    }
    if (numbers.length === 10) {
      if (numbers[2] !== '9') {
        numbers = numbers.slice(0, 2) + '9' + numbers.slice(2);
      }
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6, 10)}`;
    } else if (numbers.length === 11) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
    }
    return numbers;
  };

  // ...

  const handleSelect = () => {
    switch(selectedOption) {
      case 'Atendimento ao assinante':
        return ('atendimento-ao-assinante@opopular.com.br');
      case 'Comunicar erros':
        return ('comunicar-erros@opopular.com.br');
      case 'Quero anunciar no impresso':
        return ('quero-anunciar@opopular.com.br');
      case 'Quero Anunciar no site':
        return ('gerenciadigital@gjccorp.com.br');
      // FIXME rm classi
      case 'Classificados':
        return (
          [
            'classificados@opopular.com.br',
            'classitel@ojc.com.br',
            'opecdigital@gjccorp.com.br'
          ]
        );
      case 'Sugestão de pauta':
        return ('sugestao-de-pauta@opopular.com.br');
      case 'Fale com a redação':
        return 'fale-com-a-redacao@opopular.com.br';
      case 'Trabalhe conosco':
        return 'trabalhe-conosco@opopular.com.br';
      case 'Política de privacidade':
        return 'dpo@gjccorp.com.br';
      case 'Outros':
        return 'outros@opopular.com.br';
      default:
        return 'outros@popular.com.br';
    }
  }
  
  const clearStates = () => {
    setEmail('')
    setMessage('')
    setName('')
    setFormattedFone('')
    setInput({
      name: '',
      email: '',
      message: ''
    })
    setSelectedOption('Outros')
  }

  const handleChangeFone = (e) => {
    const fone = e.target.value
    const formattedFone = formatPhone(fone)
    setFormattedFone(formattedFone)
  }
  
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    let missingFields: string[] = [];
    if (!input.name) {
      missingFields.push("nome");
    }
    if (!input.email) {
      missingFields.push("email");
    }
    if (!selectedOption) {
      missingFields.push("assunto");
    }
    if (!input.message) {
      missingFields.push("mensagem");
    }
    if (!formattedFone) {
      missingFields.push("telefone");
    }
    if (!recaptchaToken) {
      missingFields.push("recaptcha");
    }
  
    if (missingFields.length > 0) {
      for (let field of missingFields) {
        toast.info(`O campo ${field} é obrigatório`);
      }
      return;
    }
    
    if (input.email && input.name && input.message && recaptchaToken) {
      try {
        setLoading(true)

        const storeId = getStoreId();

        const queryParams = queryString.stringify({
          from: input.email,
          text: `
            Assunto: ${selectedOption}
            Nome: ${input.name},
            E-mail: ${input.email},
            Telefone/Celular: ${formattedFone},
            Mensagem: ${input.message},
          `,
          subject: selectedOption,
          to: handleSelect(),
          contactName: input.name,
          customPhone: formattedFone,
          storeId: storeId,
        });
        const sendMailUrl = `/service-sendmail/api/send-mail?${queryParams}`;
        const response = await fetch(sendMailUrl)

        if (!response.ok) {
          throw new Error('Algo deu errado, por favor, tente novamente')
        }

        await response.json()
        toast.success('Email enviado com sucesso!');
        clearStates();
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    }
  };

  const handleRecaptcha = (token: any) => {
    setRecaptchaToken(token)
  }
    return (
      <Block
        css={{
          align: ['column', 'left', 'middle'],
          width: '100%',
          '@lg': {
            maxWidth: '904px',
          }
        }}
      >
       <Input
          onChange={(e) => handleInputChange('name', e.target.value)}
          name='name'
          onKeyPress={onKeyPress}
          placeholder='Nome'
          required
          type='text'
          value={input.name}
          css={{
            borderColor: '#E6E6E6',
            borderRadius: '$default',
            borderStyle: 'solid',
            borderWidth: '1px',
            backgroundRepeat: 'no-repeat',
            backgroundPositionX: 'calc(100% - 16px)',
            backgroundPositionY: '50%',
            color: '#4D4D4D',
            fontFamily: '$primary',
            fontSize: '16px',
            fontWeight: '$headline6',
            lineHeight: '$headline6',
            height: '45px',
            px: '$4',
            pr: '$13',
            mb: '$4',
            width: '100%',
            ...css?.input
          }}
        />
          <Block
            css={{
              align: ['column', 'center', 'middle'],
              width: '100%',
              '@lg': {
                maxWidth: '904px',
                align: ['row', 'left', 'middle'],
              }
            }}
          >
            <Input
              onChange={(e) => handleInputChange('email', e.target.value)}
              name='email'
              onKeyPress={onKeyPress}
              placeholder='E-mail'
              type='text'
              value={input.email}
              css={{
                borderColor: '#E6E6E6',
                borderRadius: '$default',
                borderStyle: 'solid',
                borderWidth: '1px',
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: 'calc(100% - 16px)',
                backgroundPositionY: '50%',
                color: '#4D4D4D',
                fontFamily: '$primary',
                fontSize: '16px',
                fontWeight: '$headline6',
                lineHeight: '$headline6',
                height: '45px',
                px: '$4',
                mb: '$4',
                width: '100%',
                '@lg': {
                  display: 'flex',
                  mr: '$4',
                  width: 'calc(301px - 16px)',
                },
                ...css?.input
              }}
            />
            <Input
              onChange={handleChangeFone}
              onKeyPress={onKeyPress}
              placeholder='Telefone'
              value={formattedFone}
              type='text'
              css={{
                borderColor: '#E6E6E6',
                borderRadius: '$default',
                borderStyle: 'solid',
                borderWidth: '1px',
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: 'calc(100% - 16px)',
                backgroundPositionY: '50%',
                color: '#4D4D4D',
                fontFamily: '$primary',
                fontSize: '16px',
                fontWeight: '$headline6',
                lineHeight: '$headline6',
                height: '45px',
                width: '100%',
                mb: '$4',
                px: '$4',
                '@lg': {
                  mr: '$4',
                  width: 'calc(301px - 16px)',
                },
                ...css?.input
                  }}
              />
            <Block
              css={{
              align: ['row', 'left', 'middle'],
              mb: '$4',
              width: '100%',
              '@lg': {
                width: '301px',
              },
              'select': {
                background: 'white',
                border: '1px solid #E6E6E6',
                borderRadius: '3px',
                color: '#4D4D4D',
                fontFamily: '$primary',
                fontSize: '16px',
                height: '48px',
                paddingLeft: '4px',
                width: '100%',
                '@lg': {
                  width: '301px',
                },
              }
              }}
            >
              <select onChange={selectChange}>
               {selectionOption.map((item, key) => {
                 return (
                  <option key={key} value={item.value} selected>{item.label}</option>
                 )
               })}
              </select>
            </Block>
          </Block>  
        <textarea
          onChange={(e) => handleInputChange('message', e.target.value)}
          name='message'
          // onKeyPress={onKeyPress}
          placeholder='Mensagem'
          value={input.message}
          className='textarea__assine'
          style={{
            borderColor: '#E6E6E6',
            borderRadius: '4px',
            borderStyle: 'solid',
            borderWidth: '1px',
            backgroundRepeat: 'no-repeat',
            backgroundPositionX: 'calc(100% - 16px)',
            backgroundPositionY: '50%',
            color: '#4D4D4D',
            fontSize: '16px',
            fontWeight: '$headline6',
            lineHeight: '$headline6',
            height: '109px',
            marginTop: 16,
            marginBottom: 16,
            width: '100%',
            padding: 16,
            resize: 'none',
            paddingTop: '10px',
            paddingBottom: '90px',
            fontFamily: 'Fira Sans Condensed'
          }}
        />
        <Block
          css={{
            align: ['column', 'center', 'middle'],
            gap: '$4',
            width: '100%',
            '@lg': {
              align: ['row', 'right', 'middle'],
              maxWidth: '904px',
            }
          }}
        >
         <Block
           css={{
            marginRight: '$35'
           }}
         >
          <ReCAPTCHA 
              sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE || ''}
              onChange={handleRecaptcha}
              style={{
                width: 190
              }}
            />
         </Block>
          <Button
            onClick={handleSubmit}
            id='enviar-contato'
            variant='outlined'
            css={{
              button: {
                background: '#164194',
                borderRadius: '10px',
                height: '40px',
                paddingLeft: '$9',
                paddingRight: '$9',
                marginBottom: '$0',
                width: '120px',
              },
              label: {
                color: 'white',
                fontFamily: '$primary',
                fontSize: '14px',
                fontWeight: '600',
                textTransform: 'capitalize'
              },
            }}
          >
              {loading ? 'CARREGANDO...' : "Enviar"}
          </Button>
        </Block>  
      </Block> 
    )
  
}
  
  export default InputArea
